/*
 * Copyright (c) 2025 Frayo and HomeChef360. All Rights Reserved.
 *
 * CONFIDENTIAL & PROPRIETARY
 * This software and its source code are the confidential and proprietary
 * information of Frayo and HomeChef360. Unauthorized copying, modification,
 * distribution, disclosure, or use of this code, in whole or in part, via any
 * medium, is strictly prohibited without prior written consent.
 *
 * Violations will be subject to legal action in the State of Florida and may
 * also be pursued under applicable U.S. federal law.
 */

import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { listTiming } from "../../core/_requests";

interface timeProps {
  timing?: { data : any[]},
  listProfile: any;
}

const TimeSettings: React.FC<timeProps> = ({ timing = { data: [] } , listProfile })  => {
  const navigate = useNavigate();
const isAllDays = timing?.data?.[0]?.timingType === true;


const changeTiming = () => {
  if (listProfile?.address === null || listProfile?.address === undefined) {
    navigate("/settings/no-address-found"); // Redirect to profile details if address is null
    return; // ⛔ Prevent further execution
  }
  navigate("/settings/change-timing"); // Redirect if address is not null
};

  const formatTime = (time: string) => {
    if (!time) return ""; // Return an empty string if time is null or undefined

    // Split the time into hours and minutes, ensuring it's a valid string
    const [hourStr, minuteStr] = time.split(":");
    const hour = parseInt(hourStr, 10); // Parse the hours
    const minute = parseInt(minuteStr, 10); // Parse the minutes

    // Ensure the hour and minute are valid
    if (isNaN(hour) || isNaN(minute)) return ""; // If either is NaN, return an empty string

    const period = hour >= 12 ? "pm" : "am"; // Determine whether it's am or pm
    const formattedHour = hour % 12 || 12; // Convert to 12-hour format, 12 for 12 and 0 for midnight

    // Format the time with leading zeroes for minutes if necessary
    return `${formattedHour}:${minute < 10 ? "0" + minute : minute} ${period}`;
  };


  return (
    
  <div>
    {timing?.data?.length === 0 ? (
      // 🔹 NO TIMING ADDED
      <div className="col-12 mb-4">
        <div className="snippet-block empty">
          <a href="#" className="add-bank py-5" onClick={changeTiming}>
            <i className="material-symbols-outlined me-2">schedule</i>
            Add your Business Timings
          </a>
        </div>
      </div>
    ) : (
      // 🔹 TIMING EXISTS
      <div className="col-12 mb-4">
        <div className="snippet-block">
          <div className="head">
            <h6 className="fw-med mb-0">Business Days & Timings</h6>
            <a href="#" className="text-link" onClick={changeTiming}>
              Edit
            </a>
          </div>

          <div className="cont mt-3">
     {isAllDays ? (
  <div className="d-flex justify-content-between align-items-center mb-2">
    <p className="fw-med mb-0">
      <small>Monday – Saturday</small>
    </p>

    <p className="mid-gray mb-0">
      <small>
        {formatTime(timing.data[0]?.openingTime)} –{" "}
        {formatTime(timing.data[0]?.closingTime)}
      </small>
    </p>
  </div>
) : (
              // ✅ SPECIFIC DAYS → FULL LIST
              timing.data.map((item: any, index: number) => (
                <div className="row mb-2" key={index}>
                  <div className="col-md-3">
                    <p className="fw-med mb-0">
                      <small>{item.day}</small>
                    </p>
                  </div>

                  <div className="col-md-9">
                    {item.isClosed ? (
                      <p className="text-danger mb-0">
                        <small>Closed</small>
                      </p>
                    ) : (
                      <p className="mid-gray mb-0">
                        <small>
                          {formatTime(item.openingTime)} –{" "}
                          {formatTime(item.closingTime)}
                        </small>
                      </p>
                    )}
                  </div>
                </div>
              ))
            )}

            <hr />
            <h6 className="mb-0">Auto Online/Offline</h6>
            <p className="mb-0 mid-gray">
              <small>{timing.data[0]?.isAuto ? "Enabled" : "Disabled"}</small>
            </p>
          </div>
        </div>
      </div>
    )}
  </div>
);


};

export default TimeSettings;
